export const yellow50 = "#fdfae9";
export const yellow100 = "#fdf9da";
export const yellow200 = "#fcf3b5";
export const yellow300 = "#faed91";
export const yellow400 = "#f9e76c";
export const yellow500 = "#f8e148";
export const yellow600 = "#f6cd3b";
export const yellow700 = "#f4b92e";
export const yellow800 = "#f2a521";
export const yellow900 = "#f09114";
export const yellow1000 = "#e97f05";
export const yellowA100 = "#fdf981";
export const yellowA200 = "#fbf06c";
export const yellowA400 = "#f4d224";
export const yellowA500 = "#edba05";
export const yellowA1000 = "#564e19";
